/* eslint-disable react/prop-types */
import React from 'react';
// eslint-disable-next-line no-unused-vars
import { withRouter } from 'react-router';
import { motion } from 'framer-motion';
import { Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import OfficeIAdressnImput from './OfficeAdressImput';
import ColorButtonPurple from './ColorButtonPurple.js';
import ColorButtonWhite from './ColorButtonWhite.js';
import ImageStep2 from './images/img_step2.svg';
import StepBar from './StepBar.js';
import CopyRight from './CopyRight.js';
import { Link } from 'react-router-dom';

class Step2 extends React.Component {
  render() {
    return (
      <div>
        <motion.div
          className="contents-inner"
          animate={{
            x: 0,
            opacity: 1,
          }}
          initial={{
            x: 100,
            opacity: 0,
          }}
          exit={{
            x: -100,
            opacity: 0,
          }}
          transition={{
            duration: 0.2,
          }}
        >
          <Box textAlign="center" paddingBottom={3}>
            <h2 className="question">次にフリーアドレス率(↔固定席率)を入力ください。</h2>
            <Box mx={1}>
              <p className="step_discription1">オフィス内の全部の席を100%としておおよその割合を記入ください</p>
            </Box>
            <img width="25%" src={ImageStep2} />
          </Box>

          <Grid container alignItems="center" justify="center">
            <Grid item xs={3}>
              <OfficeIAdressnImput
                name="過去のオフィス"
                nameEN="Before covid-19"
                discript="covid-19以前のオフィス"
                dataName1="フリーアドレス率"
                dataName2="固定席率"
                handleNum1Change={(e) => this.props.handleKakoFreeChange(e)}
                handleNum2Change={(e) => this.props.handleKakoKoteiChange(e)}
                num1={this.props.data.kako_free}
                num2={this.props.data.kako_kotei}
              />
            </Grid>
            <Grid item xs={3}>
              <OfficeIAdressnImput
                name="現在のオフィス"
                nameEN="Under covid-19"
                discript="covid-19影響下の現在のオフィス"
                dataName1="フリーアドレス率"
                dataName2="固定席率"
                handleNum1Change={(e) => this.props.handleNowFreeChange(e)}
                handleNum2Change={(e) => this.props.handleNowKoteiChange(e)}
                num1={this.props.data.now_free}
                num2={this.props.data.now_kotei}
              />
            </Grid>
            <Grid item xs={3}>
              <OfficeIAdressnImput
                name="今後のオフィス"
                nameEN="New normal"
                discript="働き方を改革した今後のオフィス"
                dataName1="フリーアドレス率"
                dataName2="固定席率"
                handleNum1Change={(e) => this.props.handleNewFreeChange(e)}
                handleNum2Change={(e) => this.props.handleNewKoteiChange(e)}
                num1={this.props.data.new_free}
                num2={this.props.data.new_kotei}
              />
            </Grid>
          </Grid>

          <Box paddingTop={2}>
            <Grid container justify="center">
              <Grid item xs={2}>
                <Box m={1} textAlign="right">
                  <ColorButtonWhite size="large" variant="outlined" component={Link} to="/step1">
                    BACK
                  </ColorButtonWhite>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Box m={1} textAlign="left">
                  <ColorButtonPurple size="large" variant="outlined" component={Link} to="/step3">
                    NEXT
                  </ColorButtonPurple>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <StepBar step="step2" />
          <Box marginTop={1}>
            <CopyRight />
          </Box>
        </motion.div>
      </div>
    );
  }
}

export default Step2;
